<script setup lang="ts">
import { StructuredText } from 'vue-datocms';
import Directions from '../partials/Directions.vue';
import type { SiteInfoFragment } from '#gql';

const siteInfo = useNuxtApp().$siteInfo as SiteInfoFragment;
</script>

<template>
  <div v-if="siteInfo.address" class="menu-address _hidden-vs">
    <StructuredText
      v-if="siteInfo.address"
      :data="siteInfo.address"
      class="text structured-text text-2xs"
    />
    <Directions class="directions text-2xs" />
  </div>
</template>

<style lang="scss" scoped>
.menu-address {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.menu-address > .directions {
  text-decoration: none;
}
</style>
